import { apiSlice } from "api/apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints : builder => ({
        login : builder.mutation({
            query : credentials => ({
                url : "/login",
                method : "POST",
                body : { ...credentials }
            })
        }),
        logout : builder.mutation({
            query : credentials => ({
                url : "/logout",
                method : "POST",
                body : { ...credentials }
            })
        }),
        signup : builder.mutation({
            query : credentials => ({
                url : "/signUp",
                method : "POST",
                body : { ...credentials }
            })
        }),
        activate : builder.query({
            query: token => ({ url: `/activate/${token.id}/${token.rand}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => responseData,
        }),
        passWithtoken : builder.query({
            query: token => ({ url: `/tokenPass/${token}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => responseData,
        }),
        refreshToken : builder.query({
            query: () => ({ url: `/refresh` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => responseData,
        }),
        rePass : builder.mutation({
            query : credentials => ({
                url : "/repass",
                method : "POST",
                body : { ...credentials }
            })
        }),
        newPass : builder.mutation({
            query : credentials => ({
                url : "/newPass",
                method : "PATCH",
                body : { ...credentials }
            })
        }),
        sendEmail : builder.mutation({
            query : credentials => ({
                url : "/sendMail",
                method : "POST",
                body : credentials
            })
        }),
    })
})

export const { useLoginMutation, useLogoutMutation, useSignupMutation, useActivateQuery, usePassWithtokenQuery, useLazyRefreshTokenQuery, useRePassMutation, useNewPassMutation, useSendEmailMutation } = authApiSlice ;